import GeneralButton from "../../common/GeneralButton";
import { TiPlus } from "react-icons/ti";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { PiPackageThin } from "react-icons/pi";
import { formatDate } from "../../utils/commonHelper";
const OrdersList = ({ list }) => {
  const getStatusProps = (status) => {
    switch (status) {
      case "0":
        return { text: "Pending", bgColor: "#D26E32" };
      case "1":
        return { text: "Delivered", bgColor: "#A1B030" };
      case "2":
        return { text: "Cancelled", bgColor: "#888" };
      default:
        return { text: status || "Unknown", bgColor: "#888" };
    }
  };

  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: -30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1, duration: 0.5, ease: "easeOut" }}
      className="w-full bg-[#DEE2DD]/40 rounded-[15px] py-10 px-8 overflow-auto"
    >
      {/* Placeholder top row to align layout */}
      <div className="hidden 2.5xl:flex items-center justify-end opacity-0 cursor-default">
        <GeneralButton text="Add new plan" icon={<TiPlus size={20} />} />
      </div>

      <div className="2.5xl:mt-12 2.5xl:ms-14 2.5xl:me-48 flex flex-col gap-5 2.5xl:gap-10">
        {list?.length > 0 &&
          list?.map((order, index) => {
            const statusProps = getStatusProps(order?.orderStatus);

            return (
              <div
                key={index}
                title="Click to view order details"
                onClick={() => navigate(`/account/orders/${order._id}`)}
                className="cursor-pointer min-h-[171px] bg-[#fff] rounded-[15px] ps-5 pe-8 py-4 md:py-4 gap-4 flex flex-col md:flex-row items-center justify-center md:justify-between relative"
              >
                {/* Left Section: Image & Info */}
                <div className="flex w-full flex-col md:flex-row items-center justify-center md:justify-start gap-4 mb-2 md:mb-0">
                  <div className="relative  flex items-center justify-start md:me-4 md:w-[175px]">
                    <div className="w-[100px] h-[100px] md:border md:border-gray md:rounded-full flex items-center justify-center relative" style={{rotate:"-10deg"}}>
                      {/* <PiPackageThin className="text-quaternary text-[130px]  md:text-[100px] lg:max-w-[150px]" /> */}
                      <img
                        src={
                          process.env.REACT_APP_BACKEND_URL +
                          "public/" +
                          order?.orderedItems[0]?.product?.image
                        } // Use first product's image
                        alt="image"
                        onError={(e) => {
                          e.currentTarget.src = require("../../../assets/images/link.png");
                        }}
                        className="max-w-[100px] md:max-w-[120px] xl:max-w-[130px] h-auto object-contain md:absolute md:left-2 md:-top-[5px] xl:left-1 xl:-top-[10px]"
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center w-full lg:items-center md:items-start justify-center md:justify-start">
                    <div className="md:me-8 min-w-[150px] flex  flex-col items-center md:items-start justify-center md:justify-start">
                      <p className="text-[20px] text-[24px]">
                        {order?.orderId}
                      </p>
                      <p className="text-[14px] font-mono leading-none mb-1 text-center md:text-left">
                        {order?.numberOfProducts} Product(s)
                      </p>
                      <p className="text-18pt text-quaternary leading-light mb-1">
                        {formatDate(order?.createdAt)}
                      </p>
                      <p className="text-14pt text-orange font-mono leading-light">
                        {order?.totalAmount?.$numberDecimal
                          ? order?.totalAmount?.$numberDecimal
                          : order?.totalAmount}{" "}
                        AED
                      </p>
                    </div>

                    <div className="flex items-center justify-start mt-1 lg:mt-0">
                      <GeneralButton
                        text={statusProps.text}
                        textColor="#fff"
                        icon={null}
                        bgColor={statusProps.bgColor}
                        className="cursor-default text-18pt"
                      />
                    </div>
                  </div>
                </div>

                {/* Right Section: View Details */}
                <div>
                  <GeneralButton
                    text="View details"
                    className="text-18pt"
                    onClick={() => navigate(`/account/orders/${order.id}`)}
                    icon={<TiPlus size={20} />}
                  />
                </div>
              </div>
            );
          })}
        {list?.length <= 0 && (
          <div className="w-full flex justify-center items-center py-8 px-4">
            <div className="  text-quaternary px-6 py-4 rounded-md text-center max-w-xl w-full flex flex-col items-center gap-2">
              <PiPackageThin size={80} className="text-quaternary" />
              <p className=" text-lg">No Orders Yet</p>
              <p className="text-sm text-quaternary font-mono">
                Make a purchase to see more details.
              </p>
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default OrdersList;
